import {
  SWITCH,
  TEXT,
  TEXT_EDITOR,
  SELECT
} from "../../components/Common/Const";

export const packageField = [
  {
    name: "name",
    label: "Name",
    isRequired: true,
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
      name: "currency",
      label: "Currency",
      options: [
        // { label: "Select Type", value: "0" },
        { label: "INR", value: "INR" },
        // { label: "dataProviderAPI", value: 2 },
      ],
      isRequired: true,
      type: SELECT,
      defaultValue: false,
      labelColspan: { xs: 12, md: 2, lg: 2 },
      fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
  {
      name: "intervalType",
      label: "Interval Type",
      options: [
        { label: "Select Type", value: "0" },
        { label: "DAY", value: 1 },
        { label: "MONTHLY", value: 2 },
        { label: "YEARLY", value: 3 },
      ],
      isRequired: true,
      type: SELECT,
      defaultValue: false,
      labelColspan: { xs: 12, md: 2, lg: 2 },
      fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
  {
    name: "price",
    label: "Price",
    isRequired: true,
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "intervalCount",
    label: "intervalCount",
    isRequired: true,
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "trailDays",
    label: "Trail Days",
    type: TEXT,
    isRequired: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "maxAccounts",
    label: "Max Accounts (blank = unlimited)",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "maxGroups",
    label: "Max Groups (blank = unlimited)",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "maxNotes",
    label: "Max Notes (blank = unlimited)",
    type: TEXT,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isActive",
    label: "Is Active",
    defaultValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isDisplay",
    label: "Is Display",
    defaultValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    type: SWITCH,
    name: "isDefault",
    label: "Is Default",
    defaultValue: true,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "description",
    label: "Discription",
    isRequired: true,
    type: TEXT_EDITOR,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 10, lg: 10 },
  },
];